/**
 * @author Harshitha.k
 * @description 
 */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tree, message } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import { DownloadOutlined } from '@ant-design/icons';

const { TreeNode } = Tree;

const HierarchyModal = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedArray, setCheckedArray] = useState(props.checkedValue || []);
  const [treeData, setTreeData] = useState(props.treeData || []);
  // const autoExpandParent = true; // This can be a state if you want to manage it

  useEffect(() => {
    setCheckedArray(checkedArray);
    setTreeData(props.treeData || []);
  }, [props.checkedValue, props.treeData]);

  useEffect(() => {
    getDeviceList();
  }, []);

  const getDeviceList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `/api/device/list?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then((res) => {
        setDeviceList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
  //   if (obj && obj.children) {
  //     let children = obj.children.map((objChildren) => {
  //       return renameProperty(objChildren, oldName1, newName1, oldName2, newName2);
  //     });
  //     obj['children'] = children;
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   } else {
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   }
  // };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={`${setTranslation(item.Name)}${
                item.Name ? `-${setTranslation(item.key)}` : ''
              }`}
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={item.key}
            title={
              <div
                style={{ fontWeight: item.Type === 'Device' ? 'bold' : 'none' }}
                onClick={() => getData(item)}
              >
                {`${setTranslation(item.Name)}${
                  item.Name ? `-${setTranslation(item.key)}` : ''
                }`}
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };

  const setTranslation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getData = (selectedKey) => {
    onSelect([selectedKey.Code]);
  };

  const onSelect = (selectedKeys) => {
    let deviceObject =
      deviceList &&
      Array.isArray(deviceList) &&
      deviceList.filter((device) => {
        return device.AliasCode === selectedKeys[0];
      });
    if (deviceObject && deviceObject.length > 0 ) {
      props.handleDropdownChange(selectedKeys,treeData, deviceList);
    } else {
      message.error('Please select valid equipment');
    }
  };

  // const getData = (selectedKey) => {
  //   let deviceObject =
  //     deviceList &&
  //     Array.isArray(deviceList) &&
  //     deviceList.filter((device) => {
  //       return device.DeviceCode === selectedKey.key;
  //     });
  //     console.log(deviceObject,'deviceObject',selectedKey.key);
  //   if (deviceObject && deviceObject.length > 0) {
  //     props.handleDropdownChange([selectedKey.key],treeData, deviceList);
  //   } else {
  //     message.error('Please select valid equipment');
  //   }
  // };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  return (
    <div style={{ height: '70%', marginTop: '10px' }}>
      <Tree
        showLine
        defaultExpandAll={true}
        switcherIcon={<DownloadOutlined />}
        onExpand={onExpand? onExpand : expandedKeys}
        checkedKeys={checkedArray}
      >
        {renderTreeNodes(treeData)}
      </Tree>
    </div>
  );
};

export default HierarchyModal;

